// Types
import type { ICsvRowGenerator } from '~/shared/import/services/csv-row-generator/types';
import type { TBaseImportRow, TImportColumnIndexes, TUprnImportRow } from '~/shared/import/types';
import { EImportParamKey } from '~/shared/import/types';

// Services
import { BaseCsvRowGenerator } from '~/shared/import/services/csv-row-generator/base';

export class UprnCsvRowGenerator
  extends BaseCsvRowGenerator
  implements ICsvRowGenerator<TUprnImportRow>
{
  handle(
    rawData: string[],
    headerIndexes: TImportColumnIndexes,
    selectedSourceName: string | null,
    processedRowsCount: number,
    index: number
  ): TUprnImportRow {
    const row: TBaseImportRow = this.generateBasic(
      rawData,
      headerIndexes,
      selectedSourceName,
      processedRowsCount,
      index
    );

    return {
      ...row,
      uprn:
        headerIndexes[EImportParamKey.UPRN] !== undefined
          ? Number(rawData[headerIndexes[EImportParamKey.UPRN]])
          : undefined,
    };
  }
}
